import React from 'react';
import clsx from 'clsx';

import { getMedia } from '../../media-store/mediaStore';

import scss from './ResponseItem.module.scss';

function VideoItem({ mediaId }) {
  const mediaData = getMedia(mediaId);

  return (
    <video
      className={clsx(scss.mediaSizes, scss.messageContainer)}
      controls
      src={`data:video/mp4;base64,${mediaData.base64}`}>
      <track kind='captions' />
    </video>
  );
}

export default VideoItem;
